import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SupportType } from './support.model';

@Injectable({
  providedIn: 'root',
})
export class SupportTicketService {
  private _http = inject(HttpClient);

  sendTicket$(
    title: string,
    message: string,
    mail: string,
    supportType: SupportType,
    productSlug?: string,
    file?: File,
  ): Observable<any> {
    const data: FormData = new FormData();
    data.append('subject', title);
    data.append('content', message);
    data.append('supportType', supportType);

    if (productSlug) {
      data.append('product_perimeter_slug', productSlug);
    }
    if (file) {
      data.append('source', file, file.name);
    }
    return this._http.post(`/api/support`, data);
  }
}
